import React from 'react';
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import PrivateRoute from './router/PrivateRoute';
import { AuthProvider } from './components/auth/AuthContext';
import WorkspaceLayout from './components/WorkspaceLayout/WorkspaceLayout';
import InspirationCanvas from './pages/inspirationCanvas/InspirationCanvas';
import TaskRecordsPage from './pages/taskRecords/TaskRecordsPage';
import CanvasEditor from './pages/canvasEditor/CanvasEditor';
import PointsRechargePage from './pages/recharge/PointsRechargePage';
import Login from './pages/login/Login';
import TokenLogin from './pages/login/TokenLogin';
import './styles/light-theme.css';

const InspirationWorkspace = () => (
  <WorkspaceLayout>
    <InspirationCanvas />
  </WorkspaceLayout>
);

const TaskRecordsWorkspace = () => (
  <WorkspaceLayout>
    <TaskRecordsPage />
  </WorkspaceLayout>
);

const RechargeWorkspace = () => (
  <WorkspaceLayout>
    <PointsRechargePage />
  </WorkspaceLayout>
);

export function AppRoutes() {
  return (
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route exact path="/token-login" component={TokenLogin} />
      <Route exact path="/" component={InspirationWorkspace} />
      <PrivateRoute exact path="/task-records" component={TaskRecordsWorkspace} />
      <PrivateRoute exact path="/recharge" component={RechargeWorkspace} />
      <Route path="/canvas-editor/:projectId" component={CanvasEditor} />
      <Redirect exact from="/inspiration-canvas" to="/" />
      <Redirect to="/" />
    </Switch>
  );
}

function App() {
  return (
    <HashRouter>
      <AuthProvider>
        <AppRoutes />
        <ToastContainer
          position="top-right"
          autoClose={3200}
          newestOnTop
          closeOnClick
          theme="light"
        />
      </AuthProvider>
    </HashRouter>
  );
}

export default App;
